<template>
  <FreeTemplatePage :template="template" />
</template>

<script setup>
// One generated module per template (modules/page-data.ts), so a page downloads only its own.
import templatesLoaders from '#build/page-data/templates-loaders.mjs';

const route = useRoute();
const template = await templatesLoaders[route.params.slug]?.();

if (!template) {
  throw createError({ statusCode: 404, statusMessage: 'Template not found' });
}
</script>
